import React from 'react';
import './Componenst.css';
import AutoModel from '../models/AutoModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createAuto, showError} from '../ViewCreator';

function Auto({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new AutoModel();


    const clearSubmit = () => {
        
        document.getElementById('descAuto').value = '';
        document.getElementById('color').value = '';
        document.getElementById('number').value = '';
        document.getElementById('model').value = '';
        personModel.infoAuto = ''
        personModel.descAuto = ''
        personModel.color = ''
        personModel.number = ''
        personModel.model = ''
        if (searchModel != undefined) {
            searchModel.auto.infoAuto = ''
            searchModel.auto.descAuto = ''
            searchModel.auto.color = ''
            searchModel.auto.number = ''
            searchModel.auto.model = ''
        }
    }

    const addSubmit = () => {
      if (personModel.model == undefined || personModel.model == '') {
        showError('Марка не може бути пустою')
        return;
    }

    if (personModel.number == undefined || personModel.number == '') {
        showError('Номер не може бути пустим')
        return;
    }

    if (personModel.color == undefined || personModel.color == '') {
        showError('Колір не може бути пустим')
        return;
    }
              isUniq()
        }
    
        const isUniq = () => {
            var path = ip + '/api/auto/search';
            personModel.searchModel = new SearchModel()
            var pp = new AutoModel();
            pp.color = personModel.color
            pp.number = personModel.number
            pp.model = personModel.model
            var bd = encryptAes(JSON.stringify(pp))
            const requestOptions = {
              headers: {
                'Content-Type': 'Content-type: text/html'
              },
              credentials: 'include',
              uri: path,
              encoding: 'latin1',
              body: bd,
              method: 'POST'
            };
            fetch(path, requestOptions)
              .then()
              .then(response => { return response.arrayBuffer() })
              .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                  var result = JSON.parse(text);
                  showError(result.msg)
                 
        
                } catch (error) {
                  const decryptedText = decryptAes(text);
                  var result = JSON.parse(decryptedText);
                  storeKey('test_data', result.key);
        
                  if (result.data.length > 0) {
                    Swal.fire({
                        title: 'Запис уже існує',
                        //text: "Оновити інформацію?",
                        icon: 'warning',
                        html:
                        'Запис з такими даними вже існує, Ви можете ' +
                        '<a href="/auto?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: 'ОК',
                          denyButtonText: 'Оновити',
                          background: '#2B2B2B',
                          color: '#FFF'
                        }).then((result) => {
                        })
                      sendSearch()
                  } else {
                    Swal.fire({
                      title: 'Ви дійсно бажаєте створити новий запис',
                      //text: "Оновити інформацію?",
                      icon: 'question',
                      html:
                      '',
                      showDenyButton: false,
                      showCancelButton: true,
                      confirmButtonText: 'Створити',
                      denyButtonText: 'Оновити',
        
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                      addNewAuto()
                      })
                    
                  }
                }
              })
          }
    
          const addNewAuto = () => {
            var path = ip + '/api/auto/add';
            personModel.searchModel = new SearchModel()
            var bd = encryptAes(JSON.stringify(personModel))
            const requestOptions = {
              headers: {
                'Content-Type': 'Content-type: text/html'
              },
              credentials: 'include',
              uri: path,
              encoding: 'latin1',
              body: bd,
              method: 'POST'
            };
            fetch(path, requestOptions)
              .then()
              .then(response => { return response.arrayBuffer() })
              .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                  var result = JSON.parse(text);
                  showError(result.msg)
                } catch (error) {
                  const decryptedText = decryptAes(text);
                  var result = JSON.parse(decryptedText);
                  storeKey('test_data', result.key);
                  if (isAdd) {
                    addNew(result.data, 20002)
                    clearSubmit()
                  } else {
                  window.open("/edit/auto?id="+result.data, "_self")
                  }
                }
              })
          }

    const sendAutoFullScreen = (id) => {
            window.open("/auto?id=" + id)
        }
    
        const sendAuto = (id) => {
            var path = ip + '/api/auto/id';
           var bd = encryptAes(id)
               const requestOptions = {
                 headers: {
                   'Content-Type': 'Content-type: text/html; charset=win1251'
                 },
                 credentials: 'include',
                 uri: path,
                 encoding: 'latin1',
                 body: bd,
                 method: 'POST'
               };
               fetch(path, requestOptions)
               .then()
               .then(response => { return response.arrayBuffer() })
               .then((buffer) => {
                    const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                    const text = decoder.decode(buffer);
                    try {
                        var result = JSON.parse(text);
                        showError(result.msg)
    
                    } catch (error) {
                        const decryptedText = decryptAes(text);
                        var result = JSON.parse(decryptedText);
                        storeKey('test_data', result.key);
    
                        var zz = []
                    
                        var addr = result.data
                        
                        zz.push(createAuto(addr))
        
                        String.prototype.replaceAt = function(index, replacement) {
                          return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                        }
                        var spr =  document.createElement('div');
                        spr.className = "spravka"
                        
                        spr.innerHTML = "<hr><p>"+addr.infoAuto.replace(/\r\n/g, "<p>"); 
                        zz.push(spr)
        
                        setView(zz)
                    }
                })
        }

    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/auto/search';
    personModel.searchModel = new SearchModel()
    var bd = encryptAes(JSON.stringify(personModel))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
          showError(result.msg)
         

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []
                  
                  for (let index = 0; index < result.data.length; index++) {
                    var z = document.createElement('div'); // is a node
                    var pers = result.data[index]
                    z.className = "listItem"
                    z.innerHTML = "<p align=\"left\">"+pers.model + "<br>"+ pers.number + "<br>" + pers.color;
                    z.style.display = "block";
                    const cl = i => () =>{
                        sendAuto(i)
                    }
                    const dblcl = i => () =>{
                        sendAutoFullScreen(i)
                    }
                    //z.onclick = cl(pers.id)
                    z.ondblclick = dblcl(pers.id)

                    var per = new AutoModel()
                    per.id = pers.id
                    z.value = per

                    
                    zz.push(z);
                   
                    
                  }
                  
          changeSearch(zz)
        }
      })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                   
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                            if(id=='model'){
                                personModel.model = l[index]
                              }
                              if(id=='number'){
                                personModel.number = l[index]
                              }
                              if(id=='color'){
                                personModel.color = l[index]
                              }
                              if(id=='descAuto'){
                                personModel.descAuto = l[index]
                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }

    

    const modelchange = () => {
        personModel.model = document.getElementById('model').value
        changedfield('model');
      }
    
      const numberchange = () => {
        personModel.number = document.getElementById('number').value
        changedfield('number');
      }
    
      const colorchange = () => {
        personModel.color = document.getElementById('color').value
        changedfield('color');
      }
    
      
    
      const descAutochange = () => {
        personModel.descAuto = document.getElementById('descAuto').value
        changedfield('descAuto');
      }

    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-auto" className="clear-button-right" onClick={clearSubmit}>Очистити
                  </button>
          <button id="add-button-auto" className="add-button-right" onClick={addSubmit}>Додати
                  </button>
        <form onSubmit={handleSubmit} className="form">
          <input className="input-button-right" id="input-button-auto" type="submit" value="Пошук" />
          
          <div id="descAutoDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="descAuto" className="input-text" tabIndex="8" name="login" type="text" onChange={descAutochange} placeholder="Опис" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="descAutoList" className="list" />
                </div>

          

          <div id="colorDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="color" className="input-text" tabIndex="3" name="login" type="text" onChange={colorchange}  placeholder="Колір" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="colorList" className="list" />
          </div>
          <div id="numberDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="number" className="input-text" tabIndex="2" name="login" type="text" onChange={numberchange}  placeholder="Держ. номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="numberList" className="list" />
          </div>
          <div id="modelDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="model" className="input-text" tabIndex="1" name="login" type="text" onChange={modelchange}  placeholder="Марка" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="modelList" className="list" />
          </div>
          
          
        </form>
        </div>
    );
}

export default Auto;